import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Col, Divider, Modal } from "antd";
import { FiUser, FiSettings, FiLogOut, FiChevronDown } from "react-icons/fi";
import { UserLogout } from "../../../redux/Login/LoginActions";
import { getUserList } from "../../../redux/Settings/SettingsActions";

export default function HeaderUser() {
  const history = useHistory();
  const dispatch = useDispatch();

  const [userName, setUserName] = useState("User");
  const [userId, setUserId] = useState(null);
  const [spinStatus, setSpinStatus] = useState(false);

  const { userList } = useSelector((state) => state.settings);

  useEffect(() => {
    const storedUserName = localStorage.getItem("userName");

    if (storedUserName) {
      setUserName(storedUserName);
      getData(storedUserName);
    }
  }, []);

  const getData = async () => {
    const payload = {
      Code: "",
      Name: "",
      Manager: "",
      Deparment: "",
    };

    setSpinStatus(true);
    await getUserList(payload);
    setSpinStatus(false);
  };

  useEffect(() => {
    const storedUserName = localStorage.getItem("userName");
    if (!userList || !storedUserName) return;

    let parsedList = [];

    try {
      parsedList =
        typeof userList === "string" ? JSON.parse(userList) : userList;
    } catch (e) {
      console.error("Failed to parse userList:", e);
    }

    const sortedList = parsedList?.sort((a, b) => b.Id - a.Id);

    const currentUser = sortedList.find(
      (user) => user.UserName === storedUserName
    );

    if (currentUser) {
      setUserId(currentUser.Id);
    }
  }, [userList]);

  const handleLogout = () => {
    UserLogout();
    localStorage.clear();
    history.push("/login");
  };

  const handleLogoutModal = () => {
    Modal.confirm({
      content: "Are you sure you want to logout?",
      okText: "Yes",
      cancelText: "No",
      onOk: handleLogout,
    });
  };

  const menu = (
    <div
      className="hp-border-radius hp-border-1 hp-border-color-black-40 hp-bg-black-0 hp-bg-dark-100 hp-border-color-dark-80 hp-p-24 hp-mt-12"
      style={{ width: 260 }}
    >
      <span className="hp-d-block h5 hp-text-color-black-100 hp-text-color-dark-0 hp-mb-8">
        Profile
      </span>
      <Divider className="hp-mt-6 hp-mb-6" />

      <Link
        to={`/settings/usermaster/adduser?id=${userId}`}
        className="hp-p1-body hp-text-color-primary-1 hp-hover-text-color-primary-2"
      >
        <p className="hp-d-flex-center hp-font-weight-500 hp-my-4 hp-py-8 hp-px-10 hp-transition hp-hover-bg-primary-4 hp-hover-bg-dark-80">
          <FiUser className="hp-mr-8" /> View Profile
        </p>
      </Link>
      <Divider className="hp-mt-6 hp-mb-6" />
      <p
        className="hp-d-flex-center hp-font-weight-500 hp-my-4 hp-py-8 hp-px-10 hp-transition hp-hover-bg-dark-80 hp-cursor-pointer"
        onClick={handleLogoutModal}
      >
        <FiLogOut className="hp-mr-8" />
        Log out
      </p>
    </div>
  );

  return (
    <Col>
      <Dropdown overlay={menu} placement="bottomLeft">
        <div className="hp-cursor-pointer hp-d-flex hp-align-items-center">
          <span className="hp-text-color-black-100 hp-text-color-dark-0 hp-mr-4 h5">
            {userName}
          </span>
          <FiChevronDown />
        </div>
      </Dropdown>
    </Col>
  );
}
